import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { indexOf as _indexOf, isEmpty as _isEmpty } from 'lodash';
import ActionTypes from '../../../constants/ActionTypes';
import { stateManagement } from '@gisatcz/ptr-utils';
export var INITIAL_STATE = {
  components: {
    byKey: {},
    inUse: []
  },
  sets: {
    byKey: {}
  }
};
/**
 * Remove component key from the list of usages
 * @param state {Object}
 * @param componentKey {string}
 * @return {Object} updated state
 */

var componentUseClear = function componentUseClear(state, componentKey) {
  if (componentKey && !_isEmpty(state.components.inUse)) {
    var index = _indexOf(state.components.inUse, componentKey);

    if (index > -1) {
      var updatedInUse = stateManagement.removeItemByIndex(state.components.inUse, index);
      return _objectSpread(_objectSpread({}, state), {}, {
        components: _objectSpread(_objectSpread({}, state.components), {}, {
          inUse: updatedInUse
        })
      });
    } else {
      return state;
    }
  } else {
    return state;
  }
};
/**
 * Add component key to the list of usages
 * @param state {Object}
 * @param componentKey {string}
 * @return {Object} updated state
 */


var componentUseRegister = function componentUseRegister(state, componentKey) {
  if (componentKey) {
    return _objectSpread(_objectSpread({}, state), {}, {
      components: _objectSpread(_objectSpread({}, state.components), {}, {
        inUse: [].concat(_toConsumableArray(state.components.inUse), [componentKey])
      })
    });
  } else {
    return state;
  }
};
/**
 * Set attribute keys for given component
 * @param state {Object}
 * @param componentKey {string}
 * @param attributeKeys {Array}
 * @return {Object} updated state
 */


var setComponentAttributeKeys = function setComponentAttributeKeys(state, componentKey, attributeKeys) {
  if (componentKey && attributeKeys !== null && attributeKeys !== void 0 && attributeKeys.length) {
    return _objectSpread(_objectSpread({}, state), {}, {
      components: _objectSpread(_objectSpread({}, state.components), {}, {
        byKey: _objectSpread(_objectSpread({}, state.components.byKey), {}, _defineProperty({}, componentKey, state.components.byKey[componentKey] ? _objectSpread(_objectSpread({}, state.components.byKey[componentKey]), {}, {
          attributeKeys: attributeKeys
        }) : {
          attributeKeys: attributeKeys
        }))
      })
    });
  } else {
    return state;
  }
};
/**
 * Set attribute order for given component
 * @param state {Object}
 * @param componentKey {string}
 * @param attributeOrder {Array}
 * @return {Object} updated state
 */


var setComponentAttributeOrder = function setComponentAttributeOrder(state, componentKey, attributeOrder) {
  if (componentKey && attributeOrder !== null && attributeOrder !== void 0 && attributeOrder.length) {
    return _objectSpread(_objectSpread({}, state), {}, {
      components: _objectSpread(_objectSpread({}, state.components), {}, {
        byKey: _objectSpread(_objectSpread({}, state.components.byKey), {}, _defineProperty({}, componentKey, state.components.byKey[componentKey] ? _objectSpread(_objectSpread({}, state.components.byKey[componentKey]), {}, {
          attributeOrder: attributeOrder
        }) : {
          attributeOrder: attributeOrder
        }))
      })
    });
  } else {
    return state;
  }
};
/**
 * Set feature keys for given component
 * @param state {Object}
 * @param componentKey {string}
 * @param featureKeys {Array}
 * @return {Object} updated state
 */


var setComponentFeatureKeys = function setComponentFeatureKeys(state, componentKey, featureKeys) {
  if (componentKey && featureKeys !== null && featureKeys !== void 0 && featureKeys.length) {
    return _objectSpread(_objectSpread({}, state), {}, {
      components: _objectSpread(_objectSpread({}, state.components), {}, {
        byKey: _objectSpread(_objectSpread({}, state.components.byKey), {}, _defineProperty({}, componentKey, state.components.byKey[componentKey] ? _objectSpread(_objectSpread({}, state.components.byKey[componentKey]), {}, {
          featureKeys: featureKeys
        }) : {
          featureKeys: featureKeys
        }))
      })
    });
  } else {
    return state;
  }
};
/**
 * Add or replace components
 * @param state {Object}
 * @param componentsByKey {Object}
 * @return {Object}
 */


var addOrReplaceComponents = function addOrReplaceComponents(state, componentsByKey) {
  if (componentsByKey) {
    return _objectSpread(_objectSpread({}, state), {}, {
      components: _objectSpread(_objectSpread({}, state.components), {}, {
        byKey: _objectSpread(_objectSpread({}, state.components.byKey), componentsByKey)
      })
    });
  } else {
    return state;
  }
};
/**
 * Add or replace sets
 * @param state {Object}
 * @param setsByKey {Object}
 * @return {Object}
 */


var addOrReplaceSets = function addOrReplaceSets(state, setsByKey) {
  if (setsByKey) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sets: _objectSpread(_objectSpread({}, state.sets), {}, {
        byKey: _objectSpread(_objectSpread({}, state.sets.byKey), setsByKey)
      })
    });
  } else {
    return state;
  }
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.DATA.COMPONENTS.COMPONENT.SET.ATTRIBUTE_KEYS:
      return setComponentAttributeKeys(state, action.componentKey, action.attributeKeys);

    case ActionTypes.DATA.COMPONENTS.COMPONENT.SET.ATTRIBUTE_ORDER:
      return setComponentAttributeOrder(state, action.componentKey, action.attributeOrder);

    case ActionTypes.DATA.COMPONENTS.COMPONENT.SET.FEATURE_KEYS:
      return setComponentFeatureKeys(state, action.componentKey, action.featureKeys);

    case ActionTypes.DATA.COMPONENTS.COMPONENT.USE.CLEAR:
      return componentUseClear(state, action.componentKey);

    case ActionTypes.DATA.COMPONENTS.COMPONENT.USE.REGISTER:
      return componentUseRegister(state, action.componentKey);

    case ActionTypes.DATA.COMPONENTS.ADD_COMPONENTS:
      return addOrReplaceComponents(state, action.components);

    case ActionTypes.DATA.COMPONENTS.ADD_SETS:
      return addOrReplaceSets(state, action.sets);

    default:
      return state;
  }
});